import { Grid, IconButton, Tooltip } from '@mui/material';
import { FunctionariesSwitchboardActionsProps } from './props';
import { useFunctionariesSwitchboardListActions } from './hook';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export const FunctionariesSwitchboardListActions = ({
    id,
    onDelete,
}: FunctionariesSwitchboardActionsProps) => {
    const { handleEdit, handleDelete } =
        useFunctionariesSwitchboardListActions(id, onDelete);
    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
            <Tooltip title="Eliminar">
                <IconButton size="small" onClick={handleDelete}>
                    <DeleteIcon sx={{ color: '#d32f2f' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
